const Footer = () => (
    <div className="footer-wrap">
      <div>© {new Date().getFullYear()} Sonodome / All rights reserved</div>
      <div></div>
    </div>
  );

export default Footer;
